// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"BottomNav_bottomNav__1iUXX","paginatorContainer":"BottomNav_paginatorContainer__2KkJj"};